import React from "react";
import "./customModal.css";

export const BuyPrModal = ({
  show,
  onClose,
  onClick,
  title = "",
  message = "",
  icon,
  primaryBtn = "Confirm",
  secondaryBtn = "",
  onSecondaryClick,
}) => {
  if (!show) return null;

  return (
    <div className="modal d-block" tabIndex="-1" style={{ background: "rgba(0,0,0,0.5)" }}>
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content rounded-4 p-1 position-relative">
          <div className="d-flex justify-content-end" style={{ padding: '0px', margin: '10px 15px 0px' }}>
            <button
              type="button"
              className="btn-close top-0 end-0 p-0 m-0"
              // aria-label="Close"
              onClick={onClose}
              style={{ cursor: 'pointer' }}
            ></button>
          </div>

          <div className="modal-body text-center px-4 pb-4 pt-0">
            {icon && (
              <div className="mb-3">
                <img src={icon} alt="icon" style={{ width: 60 }} />
              </div>
            )}
            <h5 className="fw-bold mb-2">{title}</h5>
            <p className="text-muted mb-4">{message}</p>

            <div className="d-flex justify-content-center gap-3 mt-2 mb-2">
              <button
                className="d-flex align-items-center justify-content-center px-3 py-2 fw-bold text-white"
                style={{
                  background: '#595fde',
                  borderRadius: '25px',
                  fontSize: '16px',
                  lineHeight: '24px',
                  border: 'none',
                }}
                onClick={onClick}
              >
                {primaryBtn}
              </button>
              {secondaryBtn && (
                <button
                  className="d-flex align-items-center justify-content-center px-3 py-2 fw-bold"
                  style={{
                    background: 'transparent',
                    color: '#595fde',
                    borderRadius: '25px',
                    fontSize: '16px',
                    lineHeight: '24px',
                    border: '2px solid #595fde',
                  }}
                  onClick={onSecondaryClick}
                >
                  {secondaryBtn}
                </button>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
